<template>
  <v-app style="background-color:white">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm12 md6>

            <v-card flat style="padding:0px;border-radius:0px">
              <v-layout row wrap>
                <v-flex xs6 sm6 md6 class="lftsid res" style="border:1px solid;border-color:white;color:white">
                    <v-container>
                      <h2>Register Yourself</h2>
                      <h5 style="padding-top:10px">Looks like you're new here ! Give your details to get started</h5>
                    
                      <img src="../../assets/Csquad_logo.png" height="200px" class="center" style="margin-top:20px"/>
                    </v-container>
                </v-flex>
                <v-flex xs12 sm12 md6>  
                  <div style="text-align:right">
                    <v-icon large style="cursor:pointer" @click="back()">clear</v-icon>
                  </div>
                   <v-form class="login-form" ref="form" v-model="valid" lazy-validation v-if="otpDialog==false">
                     <v-layout row wrap style="margin-top:20px">
                       <v-flex xs12 sm12 md12>
                         <h5 class="txtt" style="text-align:left">Register As a Vendor</h5>
                         <h6 class="txt" style="text-align:left">Please put your details to register</h6>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="padding-right:20px;">
                          <v-text-field
                          v-model="form.mobileNumber"
                          append-icon="phone"
                          name="login"
                          label="Enter mobile No *"
                          type="text"
                          :rules="[rules.mobileno]" required
                          ></v-text-field>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="text-align:right">
                          <v-btn
                            depressed
                            block
                            color="#E4573D"
                            :loading="loginBtn"
                            class="white--text"
                            @click="onSubmit()"
                          >
                            SEND OTP
                          </v-btn>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="text-align:center;padding-top:25px">
                         <h6>Forgot password ? <span style="color:#3486D7" class="click" @click="forgotPassword()">Click Here</span></h6>
                         <h6 style="padding-top:15px"><span style="color:#3486D7" class="click" @click="loginPage()">Already have an account? Login now</span></h6>
                       </v-flex>
                     </v-layout>
                   </v-form>

                   <v-form class="login-form" ref="form1" v-model="valid" lazy-validation v-if="otpDialog==true">
                     <v-layout row wrap style="margin-top:20px">
                       <v-flex xs12 sm12 md12>
                         <h5 class="txtt" style="text-align:left">ENETR OTP</h5>
                         <h6 class="txt" style="text-align:left">OTP has been send to (+91) {{form.mobileNumber}}</h6>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="padding-right:20px;">
                          <v-text-field
                          v-model="form1.otp"
                          name="login"
                          label="Enter OTP *"
                          type="text"
                          :rules="rules.emptyRule" 
                          required
                          ></v-text-field>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="text-align:right">
                          <v-btn
                            depressed
                            block
                            color="#E4573D"
                            :loading="loginBtn"
                            class="white--text"
                            @click="onSubmit1()"
                          >
                            SUBMIT
                          </v-btn>
                          <v-btn
                            depressed
                            block
                            color="#E4573D"
                            class="white--text"
                            @click="onSubmit()"
                          >
                            RESEND OTP
                          </v-btn>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="text-align:center;padding-top:25px">
                         <h6>Forgot password ? <span style="color:#3486D7" class="click" @click="forgotPassword()">Click Here</span></h6>
                         <h6 style="padding-top:15px"><span style="color:#3486D7" class="click" @click="loginPage()">Already have an account? Login now</span></h6>
                       </v-flex>
                     </v-layout>
                   </v-form>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <!-- <v-footer class="black--text pa-4" style="background-color:#fcd5a6">
      <v-spacer></v-spacer>
      <div>
        &copy; {{ new Date().getFullYear() }} Developed with 💖 by
        <a
          href="http://infosyst.in/"
        >Infosyst</a>
      </div>&nbsp;&nbsp;&nbsp;&nbsp;
    </v-footer> -->
  </v-app>
</template>

<script>
import config from "../../config.json";
//import vuetifyToast from "vuetify-toast";
export default {
  data: () => ({
    menu: false,
    loading: false,
    dialog: false,
    otpDialog: false,
    loginBtn: false,
    signinBtn: false,
    submitBtn: false,
    drawer: null,
    UserName: null,
    Password: null,
    passwordShow: false,
    role: sessionStorage.roles,
    registerDialog: false,
    valid: true,

    countDown : 120,

    hey: null,

    
    form1: {
      otp: null
    },

    otp: null,

    form: {
      mobileNumber: null,
      email: null,
      passwords: null
    },

    emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
        },
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
        min: value =>
          (value != null && value.length >= 6) || "Min 6 characters",
        number: value => {
          const pattern = /[0-9]+/;
          return pattern.test(value) || "Min one number";
        },
        capital: value => {
          const pattern = /[A-Z]+/;
          return pattern.test(value) || "Min one capital letter";
        },
        small: value => {
          const pattern = /[a-z]+/;
          return pattern.test(value) || "Min one small letter";
        },
        spec: value => {
          const pattern = /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~ ]+/;
          return pattern.test(value) || "Min one special character";
        }
      },
  }),
  props: {
    source: String
  },

  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.loginBtn = true;
        this.otp = 1234; /* Math.floor(1000 + Math.random() * 9000) */
        this.axios
          .post(
            config.API + `RegistrationOtp`,
            {
              mobileNumber: this.form.mobileNumber,
              otp: JSON.parse(this.otp)
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("OTP has been Send");
            this.otpDialog = true;
            this.loginBtn = false;
          })
          .catch(() => {
            this.$toaster.error('Mobile Number is already registered');
            this.loginBtn = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    onSubmit1() {
      if (this.$refs.form1.validate()) {
        if(this.form1.otp == this.otp) {
          this.loginBtn = true;
        this.axios
          .post(
            config.API + `Registration`,
            {
              mobileNumber: this.form.mobileNumber,
              type: "Vendor"
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(resp => {
            this.$toaster.success("Successfully Registered");
            const token = resp.data.token.value.token;
            const menus = resp.data.menus;
            const loggedInUserName = resp.data.loggedInUserName;
            const loggedInUserID = resp.data.loggedInUserID;
            const roles = resp.data.roles;
            const active = resp.data.active;
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("active", active);
            sessionStorage.setItem("loggedInUserName", loggedInUserName);
            sessionStorage.setItem("loggedInUserID", loggedInUserID);
            sessionStorage.setItem("roles", roles);
            sessionStorage.setItem("menus", JSON.stringify(menus));
            this.axios.defaults.headers.common["Authorization"] = token;
            this.$router.push("/_");
          })
          .catch(() => {
            this.$toaster.error('Wrong OTP');
            this.loginBtn = false;
          });
        }
        else {
          this.$toaster.error('Wrong OTP');
          this.loginBtn = false;
        }
        
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    onSubmit2() {
      if (this.$refs.form.validate()) {
        this.loginBtn = true;
        this.otp = Math.floor(1000 + Math.random() * 9000);
        this.axios
          .post(
            config.API + `LoginOtp`,
            {
              mobileNumber: this.form.mobileNumber,
              otp: JSON.parse(this.otp)
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("OTP has been Send");
            this.otpDialog = true;
            this.loginBtn = false;
          })
          .catch(() => {
            this.$toaster.error('Mobile Number is not registered');
            this.loginBtn = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    onSubmit3() {
      if (this.$refs.form1.validate()) {
        if(this.form1.otp == this.otp) {
          this.loginBtn = true;
        this.axios
          .post(
            config.API + `Login`,
            {
              mobileNumber: this.form.mobileNumber
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(resp => {
            this.$toaster.success("Successfully Registered");
            this.otpDialog = false;
            this.registerDialog = false;
            this.loginBtn = false;
            const token = resp.data.token.value.token;
            const menus = resp.data.menus;
            const loggedInUserName = resp.data.loggedInUserName;
            const loggedInUserID = resp.data.loggedInUserID;
            const roles = resp.data.roles;
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("loggedInUserName", loggedInUserName);
            sessionStorage.setItem("loggedInUserID", loggedInUserID);
            sessionStorage.setItem("roles", roles);
            sessionStorage.setItem("menus", JSON.stringify(menus));
            this.axios.defaults.headers.common["Authorization"] = token;
            this.$router.go(-1);
          })
          .catch(() => {
            this.$toaster.error('Wrong OTP');
            this.loginBtn = false;
          });
        }
        else {
          this.$toaster.error('Wrong OTP');
          this.loginBtn = false;
        }
        
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    register() {
      this.registerDialog = true;
      this.type = "Customer";
    },
    loginPage() {
      this.registerDialog = false;
    },
    login() {
      this.loginBtn = true
      let UserName = this.UserName;
      let Password = this.Password;
      this.loading = true;
      this.$store
        .dispatch("login", { UserName, Password })
        .then(() => {
          /* if (sessionStorage.roles === 'Member') {
            this.$router.go(-1);
            this.loading = false;
          }
          else { */
            //this.$router.push("/_");
            this.$router.go(-1);
            this.loading = false;
          /* } */
        })
        .catch(err => {
          this.loading = false;
          this.loginBtn = false;
        });

    },

    countDownTimer() {
             
               if(this.countDown > 0) {
                    setTimeout(() => {
                        this.countDown -= 1
                        this.countDownTimer()
                    }, 1000)
                }
                else {
                  this.otpDialog = false;
                }
            },

    forgotPassword() {
      this.$router.push("/forgotPassword");
    },

    homePage() {
      this.$router.push("/");
    },
    back() {
      this.$router.go(-1);
    },

    signin() {
      if (this.$refs.form1.validate()) {
        this.signinBtn = true;
        this.axios
          .post(
            config.API + `Token1`,
            {
              mobileNumber: this.form1.mobileNumber
            }
          )
          .then(() => {
            this.otpDialog = true;
            this.countDown = 120;
            this.signinBtn = false;
            //this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.signinBtn = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
        this.btnSave = false;
      }
  },

   submit() {
      if (this.$refs.form2.validate()) {
      this.submitBtn = true;
      let MobileNumber = this.form1.mobileNumber;
      let Otp = this.form2.otp;
      this.$store
        .dispatch("submit", { MobileNumber, Otp })
        .then(() => {
            this.$router.go(-1);
            this.submitBtn = false;
        })
        .catch(err => {
          this.submitBtn = false;
        });
      }
    }


  },
  created() {
    this.countDownTimer();
  }
  

  
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Mulish&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@500&display=swap');
</style>
<style lang="css" scoped>
.hdr {
 font-size: 50px;
 color: #e0e0e0;
}
.hdr1 {
 color: #e0e0e0;
}
.txt {
 font-family: 'Mulish', sans-serif;
}
.txtt {
 font-family: 'Sora', sans-serif;
}
.lftsid {
  background-color: #4E97FD !important;
  background-size: cover;
  box-shadow: none !important;
  border-radius: 0px !important;
}
.login-form {
  padding: 40px;
}
.bckcolor {
  background-image: url("../../assets/loginbg.jpg");
  background-size: cover;
}
.cursr {
  cursor: pointer;
}
.v-btn {
  margin-left: 0px;
}
.txt_dec:hover {
    text-decoration: underline !important;
}
.loginPage {
  background-size:cover
}
.call-button-container {
  margin: auto;
  width: 233px;
  height: 74px;
  vertical-align: middle;
  padding: 10px;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.click:hover {
  text-decoration: underline !important;
  cursor: pointer;
}
</style>
